import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';

import { SpotWorkerHeader } from '../header/SpotWorkerHeader';
import { SpotWorkerInfoForm } from '../form/SpotWorkerInfoForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { validationByJoi } from '../../../utilities/commonValidation';
import { extractErrorMessage } from '../../../utilities/commonUtil';
import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import {
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  SPOT_WORKER_RESIDENCE_TYPE,
  SPOT_WORKER_TAB,
} from '../../../utilities/constants';

import Style from '../../../styles/componentStyle/worker/workerInfo/worker-info.scss';
import { FormList } from '../../CommonFormComponents';
import { SpotWorkerImageInfo } from '../form/SpotWorkerImageInfo';
import SpotWorkersService from '../../../services/spotWorkers/SpotWorkersService';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import SpotWorkersApi from '../../../services/spotWorkers/SpotWorkersApi';

/**
 * 現場常駐社員・非常駐入退場者基本情報ページ
 * @props {object} pageStatus ページ情報 (新規・詳細・編集)
 */
export class SpotWorkerInfo extends React.Component {
  state = {
    fieldId: SessionStorageService.getFieldId(),
    header: {
      // 現場常駐社員・非常駐入退場者基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 現場常駐社員・非常駐入退場者一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    spotWorkerInfo: {},
    validErrorMessage: {}, // バリデーションエラーメッセージ
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      title: null, // モーダルダイアログのタイトル
      message: '', // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
    },
    ccusConnectErrorMessage: null, // CCUSとの連携に失敗した時のエラーメッセージ
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = false; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.NEW ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT ||
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM
      )
    ) {
      throw new Error('props.pageStatus is invalid');
    }

    // SpotWorkerInfoForm.jsxに渡すイベント
    this.events.setValue = this.setValue.bind(this);
    this.events.validate = this.validate.bind(this);

    this.state.spotWorkerInfo = this.props.spotWorkerInfo;
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createNewPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.spotWorkerInfo != this.props.spotWorkerInfo) {
      let state = _.cloneDeep(this.state);
      state.spotWorkerInfo = nextProps.spotWorkerInfo;
      state = this.createObjectForMoveToWorkerList(state);
      this.setState(state);
    }
  }

  residentType = () => {
    return this.state.spotWorkerInfo.worker_type >= 2
      ? SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT
      : SPOT_WORKER_RESIDENCE_TYPE.RESIDENT;
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 現場常駐社員・非常駐入退場者一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    const listName =
      state.spotWorkerInfo.worker_type >= 2 ? '非常駐入退場者' : '現場常駐社員';
    state.headerButtonObject.label = listName + data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 新規作成画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createNewPageHeaderButton = state => {
    // 登録ボタン作成
    state.headerButtonObject.label = data.header.new.button.register.label;
    state.headerButtonObject.className =
      data.header.new.button.register.className;
    state.headerButtonObject.onClick = this.handlerRegisterOrUpdateWorkerInfo.bind(
      this
    );
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    if (this.residentType().id === SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT.id) {
      // 編集ボタン作成
      state.headerButtonObject.label = data.header.confirm.button.edit.label;
      state.headerButtonObject.className =
        data.header.confirm.button.edit.className;
      state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
      state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    }
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.handlerMoveToBackPage.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerRegisterOrUpdateWorkerInfo.bind(
      this
    );
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 登録・編集をやめる時にダイアログの文言を設定する
   * */
  handlerMoveToBackPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showCancelEditDialog();
        break;
      default:
        break;
    }
  };

  /**
   * 現場常駐社員・非常駐入退場者一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 前のページに戻る
   */
  backToPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.moveToWorkerList();
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.moveToWorkerConfirm(false);
        break;
      default:
        break;
    }
  };

  /**
   * 現場常駐社員・非常駐入退場者一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.close();
    location.reload();
  };

  /**
   * 現場常駐社員・非常駐入退場者詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    masterSlideLoader.show('SpotWorkerConfirm', {
      state: {
        id: `${SPOT_WORKER_TAB.BASIC_INFO.ID},${
          this.state.spotWorkerInfo.field_spot_worker_id
        }`,
      },
    });
  };

  /**
   * 現場常駐社員・非常駐入退場者編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    masterSlideLoader.show('SpotWorkerEdit', {
      state: {
        id: `${SPOT_WORKER_TAB.BASIC_INFO.ID},${
          this.state.spotWorkerInfo.field_spot_worker_id
        }`,
      },
    });
  };

  /**
   * 現場常駐社員・非常駐入退場者顔写真詳細画面に遷移する
   */
  moveToImageConfirm = () => {
    masterSlideLoader.show('SpotWorkerConfirm', {
      state: {
        id: `${SPOT_WORKER_TAB.FACE_IMAGE.ID},${
          this.state.spotWorkerInfo.field_spot_worker_id
        }`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * informationModalの文言を初期化する
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = '';
    state.informationModal.buttonText = null;
    state.ccusConnectErrorMessage = null;
    this.setState(state);
  };

  /**
   * 登録・編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response レスポンスデータ
   * */
  showErrorMessageDialog = response => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.otherErrorDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = extractErrorMessage(response);
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    this.setState(state);
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 登録・更新を実行する前に実行する処理
   * バリデーション
   */
  handlerRegisterOrUpdateWorkerInfo = () => {
    if (this.validate() !== true) {
      return;
    }

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.handlerRegisterWorkerInfo();
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.handlerUpdateWorkerInfo();
        break;
      default:
        break;
    }
  };

  /**
   * 現場常駐社員・非常駐入退場者登録
   */
  handlerRegisterWorkerInfo = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const params = SpotWorkersService.createRegisterUpdateParam(
      this.state.spotWorkerInfo
    );

    SpotWorkersApi.registerNonResident(this.state.fieldId, params)
      .then(response => {
        if (response.result) {
          this.setState(state => {
            state.spotWorkerInfo.spot_worker_id =
              response.data.entities.spot_worker_id;
            state.spotWorkerInfo.field_spot_worker_id =
              response.data.entities.field_spot_worker_id;
            state.spotWorkerInfo.entrance_worker_id =
              response.data.entities.entrance_worker_id;
            state.dialogStatus = DIALOG_STATUS.registerDialogEnabled.id;
            return state;
          });
        } else {
          this.showErrorMessageDialog(response);
        }
      })
      .catch(error => {
        this.showErrorMessageDialog(error);
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  /**
   * 現場常駐社員・非常駐入退場者更新
   */
  handlerUpdateWorkerInfo = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const params = SpotWorkersService.createRegisterUpdateParam(
      this.state.spotWorkerInfo
    );

    SpotWorkersApi.updateNonResident(
      this.state.fieldId,
      this.state.spotWorkerInfo.spot_worker_id,
      params
    )
      .then(response => {
        if (response.result) {
          this.setState({
            dialogStatus: DIALOG_STATUS.updateSuccessDialogEnabled.id,
          });
        } else {
          this.showErrorMessageDialog(response);
        }
      })
      .catch(error => {
        this.showErrorMessageDialog(error);
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * フォームに値を入れる
   * @param {*} event
   */
  setValue = event => {
    const spotWorkerInfo = _.cloneDeep(this.state.spotWorkerInfo);
    spotWorkerInfo[event.target.name] = event.target.value;
    if (event.target.name === 'worker_type' && event.target.value == 3) {
      spotWorkerInfo['company_name'] = '';
    }
    this.setState({ spotWorkerInfo });
  };

  /**
   * バリデーション
   * @param {string} keyName
   */
  validate = (keyName = null) => {
    const stateValue = _.cloneDeep(this.state);
    const validateSchema = SpotWorkersService.createValidationSchema(
      this.residentType()
    );
    const result = validationByJoi(
      Joi.object().keys(validateSchema),
      SpotWorkersService.createRegisterUpdateParam(stateValue.spotWorkerInfo)
    );

    if (isNullOrUndefinedOrEmptyStr(keyName) === false) {
      if (_.has(result.messages, keyName)) {
        stateValue.validErrorMessage[keyName] = result.messages[keyName];
      } else {
        stateValue.validErrorMessage[keyName] = '';
      }
    } else {
      //全体でバリデート
      if (result.status === false) {
        stateValue.validErrorMessage = Object.assign(
          stateValue.validErrorMessage,
          result.messages
        );
      }
    }

    this.setState(stateValue);
    return result.status;
  };

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <SpotWorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={
            Object.values(this.state.validErrorMessage).filter(v => v !== '')
              .length
          }
        />
        <div className='contruction-detail-view__bar' />

        <div className='contruction-detail-view__main'>
          <FormList className='form-list form-list--no-margin form-list-default'>
            <SpotWorkerInfoForm
              events={this.events}
              messages={this.state.validErrorMessage}
              formValues={this.state.spotWorkerInfo}
              disabledAll={this.props.pageStatus.DISABLED_ALL}
              pageStatus={this.props.pageStatus}
            />
            {this.props.pageStatus.ID !== WORKER_PAGE_STATUS.NEW.ID && (
              <SpotWorkerImageInfo spotWorkerInfo={this.state.spotWorkerInfo} />
            )}
          </FormList>
        </div>

        {/* エラーが発生した時のメッセージ */}
        <Information
          rootClassName={
            this.state.informationModal.message &&
            this.state.informationModal.message.length > 28
              ? `wide-dialog-md ${Style.refetchCompleteDialog}`
              : Style.refetchCompleteDialog
          }
          visible={
            this.state.dialogStatus === DIALOG_STATUS.otherErrorDialogEnabled.id
          }
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          onClose={() => this.closeDialog()}
        />

        {/* 新規作成・編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.backToPage()}
          onCancel={() => this.closeDialog()}
        />

        {/* 現場常駐社員・非常駐入退場者一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />

        {/* 登録成功ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.registerDialogEnabled.id
          }
          title='非常駐入退場者登録'
          confirmButtonText='顔写真を登録'
          cancelButtonText='閉じる'
          message={
            '非常駐入退場者の基本情報を登録しました。\n続けて顔認証用の顔写真が登録出来ます。'
          }
          onConfirm={() => this.moveToImageConfirm()}
          onCancel={() => this.moveToWorkerConfirm()}
          multilineText={true}
        />

        {/* 更新成功のメッセージ */}
        <Information
          rootClassName={Style.refetchCompleteDialog}
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateSuccessDialogEnabled.id
          }
          title='非常駐入退場者更新'
          message='非常駐入退場者の基本情報を更新しました。'
          buttonText='閉じる'
          onClose={() => this.moveToWorkerConfirm()}
          multilineText={true}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    new: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        register: {
          label: '登録',
          className: 'btn--effective',
        },
      },
    },
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/page/SpotWorkerInfo.jsx